import React, { useState } from "react";
import { Lock, User, Eye, EyeOff, AlertCircle } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setError(''); // Clear error when user starts typing
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.username.trim() || !formData.password.trim()) {
      setError('Bitte geben Sie Benutzername und Passwort ein');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API}/admin/login`, formData);
      
      if (response.data.success) {
        // Store session token
        localStorage.setItem('admin_session_token', response.data.session_token);
        localStorage.setItem('admin_username', response.data.username);
        localStorage.setItem('admin_expires_at', response.data.expires_at);
        
        // Set axios default header for future requests
        axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.session_token}`;
        
        onLoginSuccess(response.data);
      } else {
        setError('Login fehlgeschlagen');
      }
    } catch (err) {
      console.error('Login error:', err);
      if (err.response?.status === 401) {
        setError('Ungültige Anmeldedaten');
      } else {
        setError('Verbindungsfehler. Bitte versuchen Sie es erneut.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="login-header">
          <div className="company-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_neukunden-survey/artifacts/jcwk0oru_1_Logo_Eurosill_klein.jpg" 
              alt="Eurosill Logo" 
              className="logo-image"
            />
          </div>
          <h1>Admin-Bereich</h1>
          <p>Bestandskundenumfrage Dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">
              <User size={20} />
              Benutzername
            </label>
            <input
              id="username"
              type="text"
              value={formData.username}
              onChange={(e) => handleInputChange('username', e.target.value)}
              placeholder="Admin-Benutzername eingeben"
              disabled={isLoading}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <Lock size={20} />
              Passwort
            </label>
            <div className="password-input-wrapper">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={(e) => handleInputChange('password', e.target.value)}
                placeholder="Admin-Passwort eingeben"
                disabled={isLoading}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                disabled={isLoading}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          {error && (
            <div className="error-message">
              <AlertCircle size={20} />
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className="login-button"
          >
            {isLoading ? (
              <>
                <div className="loading-spinner"></div>
                Anmeldung läuft...
              </>
            ) : (
              <>
                <Lock size={20} />
                Anmelden
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <p>🔐 Sicherer Admin-Zugang</p>
          <p>Session läuft nach 2 Stunden Inaktivität ab</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;